export default __webpack_public_path__ + "static/media/master.b4de180f.svg";